export default "__VITE_ASSET__Bb_Nm2Wa__"